<main class="p-4 md:p-3 lg:p-2 bg-white space-y-2 h-screen overflow-y-auto pr-2">
  <section>
    <div class="mb-4 mt-2">
      <div class="text-3xl font-semibold">Regional News</div>
      <lohi-news-feed></lohi-news-feed>
    </div>
  </section>
</main>
